export default __webpack_public_path__ + "b42945eb09f9ea75986f807c7f5e5981.png";